module.exports = __webpack_public_path__ + "media/images/punslogo-643daaa7fd6b3f41efdf706e81b4acbe.png";